<script lang="ts">
  // component
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import LargeTableRow from "@distributor/svelte/Payments/LargeTableRow.svelte";
  import SmallTableRow from "@distributor/svelte/Payments/SmallTableRow.svelte";

  // stores
  import { PaymentsStore } from "@distributor/svelte/Stores/PaymentsStore";

  // data
  const loadingSpinner = window["C"].IMAGE_PATHS["loadertransparent.gif"];

  // function
  const toggleRow = event => {
    var button = event.target.closest("button");
    var row = event.target.closest("tr");
    row.classList.toggle("fizz-row-open");
    button.classList.toggle("fizz-flip-icon");
  };

  // reactives
  $: showLoadingState = !$PaymentsStore.loaded;
  $: hasTransfers = $PaymentsStore.transfers.length > 0;
</script>

<div data-testid="distributor-payments-table" class="fizz-hide-on-small">
  <table class="fizz-table fizz-table-unresponsive">
    <thead>
      <tr class="fizz-flex-row fizz-space-between">
        <th>Account</th>
        <th>
          <div style="display: inline-flex; flex-flow:row;">
            Transaction Date
            <Icon
              type="SortArrow"
              width="14"
              height="18"
              extraClassNames="margin-left--smallest sort-control-transaction_date-DESC"
            />
          </div>
        </th>
        <th>Status</th>
        <th>
          <div style="display: inline-flex; flex-flow: row;">Settlement Date</div>
        </th>
        <th>Invoice</th>
        <th>Payment Confirmation Code</th>
        <th class="fizz-text-right">Amount</th>
        <th />
      </tr>
    </thead>
    <tbody>
      {#if showLoadingState}
        <tr class="fizz-text-center">
          <td class="layout-1" colspan={7}>
            <div class="fizz-flex-row fizz-justify-center">
              <img
                alt="loader"
                src={loadingSpinner}
                style="margin-left: -5px; height: 30px; width: 30px;"
              />
            </div>
          </td>
        </tr>
      {:else if hasTransfers}
        {#each $PaymentsStore.transfers as payment}
          <LargeTableRow {payment} {toggleRow} />
        {/each}
      {:else}
        <tr class="fizz-text-center">
          <td class="layout-1" colspan={8}>
            {#if $PaymentsStore.filters.searchValue || $PaymentsStore.filters.status || $PaymentsStore.filters.startDate || $PaymentsStore.filters.endDate}
              <div class="padding--small">Nothing matches your search.</div>
            {:else}
              <strong class="padding--small"> No transfers found </strong>
              <div class="padding--smaller">
                There are no payment transfers available to be reviewed in Provi.
              </div>
            {/if}
          </td>
        </tr>
      {/if}
    </tbody>
  </table>
</div>

{#if showLoadingState}
  <div class="fizz-flex-row fizz-justify-center fizz-hide-on-large">
    <img alt="loader" src={loadingSpinner} style="margin-left: -5px; height: 30px; width: 30px;" />
  </div>
{:else if hasTransfers}
  {#each $PaymentsStore.transfers as payment}
    <SmallTableRow {payment} />
  {/each}
{:else if $PaymentsStore.filters.searchValue || $PaymentsStore.filters.status || $PaymentsStore.filters.startDate || $PaymentsStore.filters.endDate}
  <div class="fizz-hide-on-large padding--small">Nothing matches your search.</div>
{:else}
  <strong class="fizz-hide-on-large padding--small"> No transfers found </strong>
  <div class="fizz-hide-on-large padding--smaller">
    There are no payment transfers available to be reviewed in Provi.
  </div>
{/if}
